import { setURLState } from "../functions/urlstate";

export const setGlobalState = (object) => {
    return (dispatch, getState) => {
      dispatch({type: 'GLOBAL_SET_STATE', object: object});
      return Promise.resolve(true);
    }
}

export const setTimeRange = (periodstart, periodend, history, location) => {
  setURLState({'start': periodstart, 'end': periodend}, history, location);
  return setGlobalState({'periodstart': periodstart, 'periodend': periodend});
}

export const setAreaScale = (areascale, history, location) => {
  setURLState({'rowgraphs': areascale}, history, location);
  return setGlobalState({'areascale': areascale});
}

export const setGeometry = (geometry, history, location) => {
  setURLState({'g': geometry}, history, location);
  return setGlobalState({'geometry': geometry});
}